export const AnalysisMixin = {
  data () {
    return {
      smallTable: true,
      filter: true,
      fitburstForm: {
        eventid: null,
        dm: null,
        window: null,
        width: null,
        iterations: '1',
        scatteringtimescale: null,
        fixdm: false,
        badchannelmask: false,
        fixwindow: true,
        multicomponent: false,
        dm_bound: null,
        time_bound: null,
        width_bound: null,
        freqmean: '600',
        freqwidth: '400',
        burst_band: 'narrow',
        components: null,
        peaksep: null,
        peakfrac: null
      },
      jobStatus: [],
      headerLocPipelineForm: {
        id: null
      },
      rerunheaderloc: true,
      intensityDMPipelineForm: {
        id: null,
        input_dm: null,
        dm_range: null,
        downsample_factor: null,
        fcenter: null,
        bandwidth_guess: null
      },
      intensityCalibrationForm: {
        id: null,
        extend_window_left: null,
        extend_window_right: null
      }
    }
  },
  mounted () {
    document.getElementById('welcome').innerHTML = 'Welcome @' + localStorage.username
  },
  computed: {
    totalRows () {
      return this.items.length
    }
  },
  methods: {
    needcheckbox (value) {
      if (value === '') {
        return false
      }
      return true
    },
    getUserRole (roles) {
      this.userRoles = roles
      // var systemRoles = ['SYSTEM TSAR', 'SYSTEM PIPELINE EXPERT']
      var scienceRoles = ['MEMBER', 'TEAM LEADER', 'DATA QUALITY EXPERT', 'SCIENCE PIPELINE EXPERT']
      var higherRoles = ['PROJECT OFFICE', 'FRB COORDINATOR']
      this.userRole = 'MEMBER'
      for (var r = 0; r < roles.length; r++) {
        if (scienceRoles.includes(roles[r])) {
          this.userRole = roles[r]
        } else if (higherRoles.includes(roles[r])) {
          this.userRole = roles[r]
        }
      }
    },
    getDelayedData (delay, onlyFetchEventType = '', allTeams = false) {
      this.unsavedEvents = []
      this.myunsavedEvents = []
      this.badEvents = []
      this.mybadEvents = []
      this.flaggedEvents = []
      this.myflaggedEvents = []
      this.savedEvents = []
      this.mysavedEvents = []
      // Create a new Promise and resolve after 2 seconds
      var myTimerPromise = this.waitForIt(delay) // wait for 2 seconds
      var team = this.userTeam
      if (allTeams) {
        team = 'all'
      }
      if (onlyFetchEventType.length > 0) {
        Promise.all([myTimerPromise]).then(() => {
          this.fetchEvents(`${onlyFetchEventType}-for-analysis`, team)
        })
      } else {
        Promise.all([myTimerPromise]).then(() => {
          this.fetchEvents('unsaved-events-for-analysis', team)
          this.fetchEvents('saved-events-for-analysis', team)
          this.fetchEvents('flagged-events-for-analysis', team)
          this.fetchEvents('bad-events-for-analysis', team)
        })
      }
    },
    getAllData (allTeams = false) {
      this.unsavedEvents = []
      this.myunsavedEvents = []
      this.badEvents = []
      this.mybadEvents = []
      this.flaggedEvents = []
      this.myflaggedEvents = []
      this.savedEvents = []
      this.mysavedEvents = []
      var team = this.userTeam
      if (allTeams) {
        team = 'all'
      }
      this.fetchEvents('unsaved-events-for-analysis', team)
      this.fetchEvents('saved-events-for-analysis', team)
      this.fetchEvents('flagged-events-for-analysis', team)
      this.fetchEvents('bad-events-for-analysis', team)
    },
    waitForIt (waitTime) {
      // Create a new Promise and resolve after 2 seconds
      var waitPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, waitTime)
      })
      return waitPromise
    },
    fetchEvents (urlExtension, team) {
      if (team !== 'all') {
        team = this.userTeam
      }
      // edge case for users without a team, fetch all
      if (!['1', '2', '3', '4'].includes(team)) {
        team = 'all'
      }
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(this.mybaseUrl + '/v1/analysis/' + urlExtension + '/' + team, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.parseEvents(response.body, urlExtension)
        }, response => {
        })
    },
    parseResponse (sources) {
      for (var i = 0; i < sources.length; i++) {
        var item = {}
        item['dm'] = sources[i]['measured_parameters']['dm'].toFixed(1)
        item['snr'] = sources[i]['measured_parameters']['snr'].toFixed(1)
        item['ra'] = sources[i]['measured_parameters']['ra'].toFixed(1)
        item['dec'] = sources[i]['measured_parameters']['dec'].toFixed(1)
        item['width'] = sources[i]['measured_parameters']['width']
        item['datetime'] = sources[i]['measured_parameters']['datetime'].slice(0, 23)
        item['source_name'] = sources[i]['source_name']
        item['source_type'] = sources[i]['source_type']
        item['candidate_id'] = sources[i]['candidate_id']
        item['_rowVariant'] = 'danger'
        if (item['candidate_id'] !== undefined) {
          this.items.push(item)
        }
      }
      document.getElementById('candidate-heading').innerHTML = 'CHIME/FRB Candidates' + ': ' + this.items.length
    },
    parseRepeaters (sources) {
      for (var i = 0; i < sources.length; i++) {
        var item = {}
        item['dm'] = sources[i]['measured_parameters']['dm'].toFixed(1)
        item['snr'] = sources[i]['measured_parameters']['snr'].toFixed(1)
        item['ra'] = sources[i]['measured_parameters']['ra'].toFixed(1)
        item['dec'] = sources[i]['measured_parameters']['dec'].toFixed(1)
        item['width'] = sources[i]['measured_parameters']['width']
        item['datetime'] = sources[i]['measured_parameters']['datetime'].slice(0, 23)
        item['source_name'] = sources[i]['source_name']
        item['source_type'] = sources[i]['source_type']
        item['candidate_id'] = sources[i]['candidate_id']
        item['_rowVariant'] = 'danger'
        item['num_events'] = null
        item['candidate'] = null
        this.items.push(item)
      }
      document.getElementById('candidate-heading').innerHTML = 'CHIME/FRB Candidates' + ': ' + this.items.length
    },
    parseEvents (events, eventType) {
      if (eventType === 'unsaved-events-for-analysis') {
        this.unsavedEvents = []
        this.myunsavedEvents = []
      }
      if (eventType === 'saved-events-for-analysis') {
        this.savedEvents = []
        this.mysavedEvents = []
      }
      if (eventType === 'flagged-events-for-analysis') {
        this.flaggedEvents = []
        this.myflaggedEvents = []
      }
      if (eventType === 'bad-events-for-analysis') {
        this.badEvents = []
        this.mybadEvents = []
      }
      var variantMap = {'TODO': 'danger', 'GOOD': 'success', 'FLAGGED': 'warning', 'BAD': 'dark'}
      for (var i = 0; i < events.length; i++) {
        var item = {}
        item['event_id'] = events[i]['candidate_id']
        item['team'] = events[i]['team']
        item['notes'] = events[i]['notes']
        item['intensity-dm-pipeline'] = 'TODO'
        item['intensity-fitburst'] = 'TODO'
        item['intensity-calibration'] = 'TODO'
        item['header-localization'] = 'TODO'
        item['intensity-localization'] = 'TODO'
        item['baseband'] = 'TODO'
        if (Object.keys(events[i]).includes('pipeline_state')) {
          var pipelineKeys = Object.keys(events[i]['pipeline_state'])
          for (var pk = 0; pk < pipelineKeys.length; pk++) {
            item[pipelineKeys[pk]] = events[i]['pipeline_state'][pipelineKeys[pk]]
          }
        }
        item['assigned_users'] = ''
        var myEvent = false
        for (var j = 0; j < events[i]['users'].length; j++) {
          if (events[i]['users'][j] === localStorage.username) {
            myEvent = true
          }
          if (events[i]['users'][j] !== 'null') {
            if (j === 0) {
              item['assigned_users'] = item['assigned_users'] + events[i]['users'][j]
            } else {
              item['assigned_users'] = item['assigned_users'] + ', ' + events[i]['users'][j]
            }
          }
        }
        item['_cellVariants'] = {
          'intensity-dm-pipeline': variantMap[item['intensity-dm-pipeline']],
          'intensity-fitburst': variantMap[item['intensity-fitburst']],
          'intensity-calibration': variantMap[item['intensity-calibration']],
          'header-localization': variantMap[item['header-localization']],
          'intensity-localization': variantMap[item['intensity-localization']],
          'baseband': variantMap[item['baseband']],
          'event_id': 'primary',
          'team': 'primary',
          'assigned_users': 'primary',
          'snr': 'primary',
          'dm': 'primary',
          'ra': 'primary',
          'dec': 'primary',
          'actions': 'light'
        }

        if ('measured_parameters' in events[i]['event_info']) {
          item['dm'] = events[i]['event_info']['measured_parameters'][0]['dm'].toFixed(2)
          item['ra'] = events[i]['event_info']['measured_parameters'][0]['ra'].toFixed(2)
          item['dec'] = events[i]['event_info']['measured_parameters'][0]['dec'].toFixed(2)
          item['snr'] = events[i]['event_info']['measured_parameters'][0]['snr'].toFixed(2)
        }
        if (eventType === 'unsaved-events-for-analysis') {
          this.unsavedEvents.push(item)
          if (
            (myEvent) &&
            (item['header-localization'] === 'TODO' || item['intensity-dm-pipeline'] === 'TODO')
          ) {
            this.myunsavedEvents.push(item)
          }
        }
        if (eventType === 'flagged-events-for-analysis') {
          this.flaggedEvents.push(item)
          if (myEvent) {
            this.myflaggedEvents.push(item)
          }
          var eventFound = false
          for (var k = 0; k < this.unsavedEvents.length; k++) {
            if (item['event_id'] === this.unsavedEvents[k]['event_id']) {
              eventFound = true
              break
            }
          }
          if (!eventFound) {
            this.unsavedEvents.push(item)
            if (myEvent) {
              this.myunsavedEvents.push(item)
            }
          }
        }
        if (eventType === 'saved-events-for-analysis') {
          this.savedEvents.push(item)
          if (myEvent) {
            this.mysavedEvents.push(item)
          }
        }
        if (eventType === 'bad-events-for-analysis') {
          this.badEvents.push(item)
          if (myEvent) {
            this.mybadEvents.push(item)
          }
        }
      }
    },
    parseEvent (r) {
      var value = {}
      value['event_id'] = r.id
      value['timestamp_utc'] = r.measured_parameters[0].datetime
      value['datetime'] = r.measured_parameters[0].datetime.slice(0, 23)
      value['dm'] = r.measured_parameters[0].dm.toFixed(1)
      value['snr'] = r.measured_parameters[0].snr.toFixed(1)
      value['ra'] = r.measured_parameters[0].ra.toFixed(1)
      value['dec'] = r.measured_parameters[0].dec.toFixed(1)
      value['_rowVariant'] = 'danger'
      return value
    },
    parseCandidates (candidates) {
      for (var i = 0; i < candidates.length; i++) {
        var item = {}
        item['id'] = candidates[i]['id'].slice(0, 23)
        item['candidate_id'] = candidates[i]['id']
        item['candidate_type'] = candidates[i]['candidate_type']
        item['num_events'] = candidates[i]['events'].length
        if (item['num_events'] > 1) {
          item['candidate_type'] = 'Repeater'
        } else {
          item['candidate_type'] = 'FRB Candidate'
        }
        item['events'] = candidates[i]['events']
        for (var j = 0; j < this.items.length; j++) {
          var cI = null
          if (this.items[j]['candidate_id'] !== undefined) {
            cI = this.items[j]['candidate_id'][0]
          }
          if (item['candidate_id'] === cI) {
            this.items[j]['num_events'] = item['num_events']
            this.items[j]['candidate'] = item
            break
          }
        }
      }
    },
    fetchPlotData (data) {
      var frbdms = []
      var frbdecs = []
      var frbras = []
      var frbsnrs = []
      var frbwidths = []
      var frbtimes = []
      var repdms = []
      var repdecs = []
      var repras = []
      var repsnrs = []
      var repwidths = []
      var reptimes = []
      for (var i = 0; i < data.length; i++) {
        if (data[i]['source_type'] === 'FRB_REPEATER') {
          repdms.push(data[i].dm)
          repdecs.push(data[i].dec)
          repras.push(data[i].ra)
          repsnrs.push(data[i].snr)
          repwidths.push(data[i].width)
          reptimes.push(data[i].datetime)
        } else {
          frbdms.push(data[i].dm)
          frbdecs.push(data[i].dec)
          frbras.push(data[i].ra)
          frbsnrs.push(data[i].snr)
          frbwidths.push(data[i].width)
          frbtimes.push(data[i].datetime)
        }
      }
      this.data1 = [{histfunc: 'count', nbinsx: 12, x: frbtimes, type: 'histogram', name: 'FRBs'},
        {histfunc: 'count', nbinsx: 12, x: reptimes, type: 'histogram', name: 'REPEATERs'}]
      this.data2 = [{histfunc: 'count', nbinsx: 25, x: frbdecs, type: 'histogram', name: 'FRBs'},
        {histfunc: 'count', nbinsx: 25, x: repdecs, type: 'histogram', name: 'REPEATERs'}]
      this.data3 = [{histfunc: 'count', nbinsx: 15, x: frbwidths, type: 'histogram', name: 'FRBs'},
        {histfunc: 'count', nbinsx: 15, x: repwidths, type: 'histogram', name: 'REPEATERs'}]
      this.layout1 = {
        xaxis: {
          title: 'Time',
          titlefont: {size: 20},
          tickfont: {size: 15}
        },
        yaxis: {
          title: 'Num events',
          titlefont: {size: 20},
          tickfont: {size: 15}
        }
        // plot_bgcolor: 'black'
      }
      this.layout2 = {
        xaxis: {
          title: 'Dec',
          titlefont: {size: 20},
          tickfont: {size: 15}
        },
        yaxis: {
          title: 'Num events',
          type: 'log',
          titlefont: {size: 20},
          tickfont: {size: 15}
        }
        // plot_bgcolor: 'black'
      }
      this.layout3 = {
        xaxis: {
          title: 'Width (ms)',
          titlefont: {size: 20},
          tickfont: {size: 15}
        },
        yaxis: {
          title: 'Num events',
          type: 'log',
          titlefont: {size: 20},
          tickfont: {size: 15}
        }
        // plot_bgcolor: 'black'
      }
    },
    reloadData () {
      // Reload the data
      this.getDelayedData()
    },
    showSource (evItem, index, button) {
      // Fetch source plot
      for (var i = 0; i < Object.keys(evItem['_cellVariants']).length; i++) {
        evItem['_cellVariants'][Object.keys(evItem['_cellVariants'])[i]] = 'dark'
      }
      this.activeEvent = evItem.candidate_id
      this.activeEvent = evItem
      var x = document.getElementById('eventViewer')
      var plt = document.getElementById('eventPlot')
      plt.src = ''
      if (this.previousEvent['event_id'] === evItem['event_id']) {
        if (x.style.display === 'none') {
          x.style.display = 'block'
        } else {
          x.style.display = 'none'
        }
        return
      }
      var variantMap = {'TODO': 'danger', 'GOOD': 'success', 'FLAGGED': 'warning', 'BAD': 'dark'}
      this.previousEvent['_cellVariants'] = {
        'intensity-dm-pipeline': variantMap[this.previousEvent['intensity-dm-pipeline']],
        'intensity-fitburst': variantMap[this.previousEvent['intensity-fitburst']],
        'intensity-calibration': variantMap[this.previousEvent['intensity-calibration']],
        'header-localization': variantMap[this.previousEvent['header-localization']],
        'intensity-localization': variantMap[this.previousEvent['intensity-localization']],
        'baseband': variantMap[this.previousEvent['baseband']],
        'event_id': 'primary',
        'team': 'primary',
        'assigned_users': 'primary',
        'snr': 'primary',
        'dm': 'primary',
        'ra': 'primary',
        'dec': 'primary',
        'actions': 'light'
      }
      x.style.display = 'block'
      plt.src = 'https://frb.chimenet.ca/chimefrb/astro_events/show_single_event/' + evItem['event_id'] + '/'
      this.previousEvent = evItem
    },
    fetchEvent (eventUrl, inputFunctions) {
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(eventUrl, {headers: authHeaders}, {responseType: 'json', timeout: 10000}, {headers: authHeaders})
        .then(response => {
          for (var i = 0; i < inputFunctions.length; i++) {
            inputFunctions[i](response.body)
          }
        })
    },
    generateAll (evItem) {
      this.pipelineColors = {}
      this.fitburstItems = []
      this.fitburstMCMCItems = []
      this.intensityDmPipelineItems = []
      this.intensityLocalizationItems = []
      this.HeaderLocalizationItems = []
      this.basebandItems = []
      this.fluenceItems = []
      this.eventId = evItem['event_id'].toString()
      this.fitburstForm['eventid'] = evItem['event_id'].toString()
      this.headerLocPipelineForm['id'] = evItem['event_id'].toString()
      this.intensityDMPipelineForm['id'] = evItem['event_id'].toString()
      this.intensityCalibrationForm['id'] = evItem['event_id'].toString()
      var inputFunctions = [
        this.parseFluence,
        this.parseFitburst,
        this.parseFitburstMCMC,
        this.parseIntensityDMPipeline,
        this.parseIntensityLocalization,
        this.parseHeaderLocalization,
        this.parseBaseband
      ]
      var eventUrl = this.baseUrl + 'v1/events/' + evItem['event_id']
      this.fetchEvent(eventUrl, inputFunctions)
      // this.fetchColors(evItem)
    },
    fetchColors (event) {
      var colorMap = {'TODO': 'red', 'FLAGGED': 'orange', 'GOOD': 'green', 'BAD': 'blue'}
      var x = document.getElementById('dm-pipeline-summary')
      x.style.color = colorMap[event['intensity-dm-pipeline']]
      x = document.getElementById('fitburst-summary')
      x.style.color = colorMap[event['intensity-fitburst']]
      x = document.getElementById('calibration-summary')
      x.style.color = colorMap[event['intensity-calibration']]
      x = document.getElementById('header-localization-summary')
      x.style.color = colorMap[event['header-localization']]
      x = document.getElementById('intensity-localization-summary')
      x.style.color = colorMap[event['intensity-localization']]
      x = document.getElementById('baseband-summary')
      x.style.color = colorMap[event['baseband']]
      x = document.getElementById('localization-summary')
      if (colorMap[event['header-localization']] === 'green' && colorMap[event['intensity-localization']] === 'green') {
        x.style.color = 'green'
      } else {
        x.style.color = 'red'
      }
    },
    checkIfBaseband (evItem) {
      var bbUrl = this.baseUrl + '/v1/verification/get-verification/' + evItem['event_id']
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(bbUrl, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.basebandData = false
          if (response.body['data_status']['baseband_data']) {
            this.basebandData = true
          }
        })
    },
    pad (number) {
      if (number < 10) {
        return '0' + number
      }
      return number
    },
    getProcessedAt (measurementID) {
      if ((typeof measurementID === 'string') && (measurementID.includes('-') || measurementID.includes(':'))) {
        return measurementID
      }
      var date = new Date(measurementID * 1000)
      var processedAt = date.getFullYear() + '-' + this.pad(date.getMonth() + 1) + '-' + this.pad(date.getDate()) + ' ' + this.pad(date.getHours()) + ':' + this.pad(date.getMinutes()) + ':' + this.pad(date.getSeconds())
      return processedAt
    },
    parseIntensityDMPipeline (eventData) {
      try {
        var intensityDmPipelineItem = {}
        intensityDmPipelineItem['fitData'] = 0
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        for (var i = 1; i < eventData['measured_parameters'].length; i++) {
          var measurementIDToCompare = new Date(measurementID)
          if (isNaN(measurementID) === false) {
            measurementIDToCompare = new Date(measurementID * 1000)
          }
          var eventMeasurementID = eventData['measured_parameters'][i]['measurement_id']
          if (isNaN(eventMeasurementID) === false) {
            eventMeasurementID = eventMeasurementID * 1000
          }
          eventMeasurementID = new Date(eventMeasurementID)
          if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-dm-pipeline' &&
            eventMeasurementID >= measurementIDToCompare) {
            measurementID = eventData['measured_parameters'][i]['measurement_id']
            intensityDmPipelineItem['fitData'] = eventData['measured_parameters'][i]
          }
        }
        intensityDmPipelineItem['processedAt'] = this.getProcessedAt(measurementID)
        // Pad beam number with '0' to four digits
        var burstDate = eventData['measured_parameters'][0]['datetime']
        var filePath = '/data/chime/intensity/processed/' +
                        burstDate.split(' ')[0].split('-')[0] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[1] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[2] +
                        '/astro_' +
                        eventData['id'] +
                        '/intensity-dm-pipeline/'
        intensityDmPipelineItem['all_beams'] = filePath + eventData['id'] + '_all_beams_waterfall.png'
        intensityDmPipelineItem['snr_waterfall'] = filePath +
                                                  eventData['id'] +
                                                  '_snr_waterfall.png'
        intensityDmPipelineItem['structure_waterfall'] = filePath +
                                                        eventData['id'] +
                                                        '_structure_waterfall.png'
        intensityDmPipelineItem['boxcar_convolution'] = filePath +
                                                        eventData['id'] +
                                                        '_boxcar_convolution.png'
        intensityDmPipelineItem['boxcar_convolution_profiles'] = filePath +
                                                                eventData['id'] +
                                                                '_boxcar_convolution_profiles.png'
        intensityDmPipelineItem['dm_search'] = filePath +
                                              eventData['id'] +
                                              '_DM_Search.png'
        intensityDmPipelineItem['5sig'] = filePath +
                                          eventData['id'] +
                                          '_Waterfall_5sig.png'
        this.intensityDmPipelineItems.push(intensityDmPipelineItem)
      } catch (e) {
        console.error(e)
      }
    },
    parseIntensityLocalization (eventData) {
      try {
        var intensityLocalizationItem = {}
        intensityLocalizationItem['fitData'] = 0
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        for (var i = 1; i < eventData['measured_parameters'].length; i++) {
          var measurementIDToCompare = new Date(measurementID)
          if (isNaN(measurementID) === false) {
            measurementIDToCompare = new Date(measurementID * 1000)
          }
          var eventMeasurementID = eventData['measured_parameters'][i]['measurement_id']
          if (isNaN(eventMeasurementID) === false) {
            eventMeasurementID = eventMeasurementID * 1000
          }
          eventMeasurementID = new Date(eventMeasurementID)
          if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-localization' &&
            eventMeasurementID >= measurementIDToCompare) {
            measurementID = eventData['measured_parameters'][i]['measurement_id']
            intensityLocalizationItem['fitData'] = eventData['measured_parameters'][i]
          }
        }

        // Set number of decimals to display
        intensityLocalizationItem['fitData']['ra_list'] = intensityLocalizationItem['fitData']['ra_list'].map(ele => parseFloat(ele.toFixed(2)))
        intensityLocalizationItem['fitData']['dec_list'] = intensityLocalizationItem['fitData']['dec_list'].map(ele => parseFloat(ele.toFixed(2)))
        intensityLocalizationItem['fitData']['ra_list_error'] = intensityLocalizationItem['fitData']['ra_list_error'].map(ele => parseFloat(ele.toFixed(2)))
        intensityLocalizationItem['fitData']['dec_list_error'] = intensityLocalizationItem['fitData']['dec_list_error'].map(ele => parseFloat(ele.toFixed(2)))
        intensityLocalizationItem['fitData']['x_list'] = intensityLocalizationItem['fitData']['x_list'].map(ele => parseFloat(ele.toFixed(2)))
        intensityLocalizationItem['fitData']['y_list'] = intensityLocalizationItem['fitData']['y_list'].map(ele => parseFloat(ele.toFixed(2)))
        intensityLocalizationItem['fitData']['x_list_error'] = intensityLocalizationItem['fitData']['x_list_error'].map(ele => parseFloat(ele.toFixed(2)))
        intensityLocalizationItem['fitData']['y_list_error'] = intensityLocalizationItem['fitData']['y_list_error'].map(ele => parseFloat(ele.toFixed(2)))
        if ('chi2_list' in intensityLocalizationItem['fitData']) {
          intensityLocalizationItem['fitData']['chi2_list'] = intensityLocalizationItem['fitData']['chi2_list'].map(ele => parseFloat(ele.toFixed(1)))
        } else {
          intensityLocalizationItem['fitData']['chi2_list'] = ['-', '-', '-', '-', '-']
          intensityLocalizationItem['fitData']['dof'] = '-'
        }
        intensityLocalizationItem['processedAt'] = this.getProcessedAt(measurementID)
        // Pad beam number with '0' to four digits
        var burstDate = eventData['measured_parameters'][0]['datetime']
        var filePath = '/data/chime/intensity/processed/' +
                        burstDate.split(' ')[0].split('-')[0] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[1] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[2] +
                        '/astro_' +
                        eventData['id'] +
                        '/intensity-localization/'
        intensityLocalizationItem['beamspec'] = filePath + eventData['id'] + '_Gaussian_beamspec.png'
        intensityLocalizationItem['corner'] = filePath + eventData['id'] + '_Gaussian_corner.png'
        this.intensityLocalizationItems.push(intensityLocalizationItem)
      } catch (e) {
        console.error(e)
      }
    },
    parseHeaderLocalization (eventData) {
      try {
        var HeaderLocalizationItem = {}
        HeaderLocalizationItem['fitData'] = 0
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        for (var i = 1; i < eventData['measured_parameters'].length; i++) {
          var measurementIDToCompare = new Date(measurementID)
          if (isNaN(measurementID) === false) {
            measurementIDToCompare = new Date(measurementID * 1000)
          }
          var eventMeasurementID = eventData['measured_parameters'][i]['measurement_id']
          if (isNaN(eventMeasurementID) === false) {
            eventMeasurementID = eventMeasurementID * 1000
          }
          eventMeasurementID = new Date(eventMeasurementID)
          if (eventData['measured_parameters'][i]['pipeline']['name'] === 'header-localization' &&
            eventMeasurementID >= measurementIDToCompare) {
            measurementID = eventData['measured_parameters'][i]['measurement_id']
            HeaderLocalizationItem['fitData'] = eventData['measured_parameters'][i]
          }
        }
        HeaderLocalizationItem['processedAt'] = this.getProcessedAt(measurementID)
        // Pad beam number with '0' to four digits
        var burstDate = eventData['measured_parameters'][0]['datetime']
        var filePath = '/data/chime/intensity/processed/' +
                        burstDate.split(' ')[0].split('-')[0] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[1] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[2] +
                        '/astro_' +
                        eventData['id'] +
                        '/header-localization/'
        HeaderLocalizationItem['header-localization'] = filePath + eventData['id'] + '_header-localization.png'
        this.HeaderLocalizationItems.push(HeaderLocalizationItem)
      } catch (e) {
        console.error(e)
      }
    },
    parseFluence (eventData) {
      try {
        var fluenceItem = {}
        fluenceItem['fitData'] = 0
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        for (var i = 1; i < eventData['measured_parameters'].length; i++) {
          var measurementIDToCompare = new Date(measurementID)
          if (isNaN(measurementID) === false) {
            measurementIDToCompare = new Date(measurementID * 1000)
          }
          var eventMeasurementID = eventData['measured_parameters'][i]['measurement_id']
          if (isNaN(eventMeasurementID) === false) {
            eventMeasurementID = eventMeasurementID * 1000
          }
          eventMeasurementID = new Date(eventMeasurementID)
          if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-calibration' &&
            eventMeasurementID >= measurementIDToCompare) {
            measurementID = eventData['measured_parameters'][i]['measurement_id']
            fluenceItem['fitData'] = eventData['measured_parameters'][i]
          }
        }
        fluenceItem['processedAt'] = this.getProcessedAt(measurementID)
        // Pad beam number with '0' to four digits
        var mainBeam = ('0000' + fluenceItem['fitData']['beam_number']).substr(-4, 4)
        var burstDate = eventData['measured_parameters'][0]['datetime']
        var filePath = '/data/chime/intensity/processed/' +
                        burstDate.split(' ')[0].split('-')[0] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[1] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[2] +
                        '/astro_' +
                        eventData['id'] +
                        '/intensity-calibration/'
        document.getElementById('calibrate_intensity_logs').innerHTML = ''
        document.getElementById('calculate_fluence_logs').innerHTML = ''
        this.$http.get('https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=' + filePath + 'calibrate_intensity.log')
          .then(response => {
            let customItems = response.body
            customItems = customItems.split('[20')
            for (let i = 0; i < customItems.length; i++) {
              if (i > 0) {
                customItems[i] = '<br/>[20' + customItems[i]
              } else {
                customItems[i] = customItems[i]
              }
            }
            customItems = customItems.join('')
            document.getElementById('calibrate_intensity_logs').innerHTML = customItems
          })
        this.$http.get('https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=' + filePath + 'calculate_fluence.log')
          .then(response => {
            let customItems = response.body
            customItems = customItems.split('[20')
            for (let i = 0; i < customItems.length; i++) {
              if (i > 0) {
                customItems[i] = '<br/>[20' + customItems[i]
              } else {
                customItems[i] = customItems[i]
              }
            }
            customItems = customItems.join('')
            document.getElementById('calculate_fluence_logs').innerHTML = customItems
          })
        fluenceItem['fluence_diagnostic'] = filePath + eventData['id'] + '_fluence_diagnostic_plot.png'
        fluenceItem['calibration_diagnostic'] = filePath + eventData['id'] + '_' + mainBeam + '_calibration_diagnostic_plot.png'
        this.fluenceItems.push(fluenceItem)
      } catch (e) {
        console.error(e)
      }
    },
    fetchJobStatus () {
      const bucks = ['intensity-dm-pipeline', 'intensity-fitburst', 'calibrate-intensity', 'calculate-fluence']
      let url = 'https://frb.chimenet.ca/maestro/buckets/status'
      this.$http.post(url, bucks, {responseType: 'json', timeout: 10000})
        .then(response => {
          let buckets = response.body
          let statuses = []
          for (let x = 0; x < buckets.length; x++) {
            let payload = buckets[x]
            let priorities = Object.keys(payload['distributors_state'])
            for (let j = 0; j < priorities.length; j++) {
              let workStatus = payload['distributors_state'][priorities[j]]['status']
              let keys = Object.keys(workStatus)
              for (let i = 0; i < keys.length; i++) {
                let status = {}
                let work = JSON.parse(keys[i])
                if (work['pipeline_user']) {
                  status['pipeline'] = payload['name']
                  status['user'] = work['pipeline_user']
                  status['priority'] = priorities[j]
                  delete work['pipeline_user']
                  status['status'] = 'Queued'
                  if (Object.keys(workStatus[keys[i]]).includes('withdrawn_at') === true) {
                    status['status'] = 'In Progress'
                  }
                  if (Object.keys(workStatus[keys[i]]).includes('concluded_at') === true) {
                    status['status'] = 'Finished'
                  }
                  status['work'] = work
                  statuses.push(status)
                }
              }
            }
          }
          this.jobStatus = statuses
        })
    },
    parseBaseband (eventData) {
      try {
        var basebandItem = {}
        basebandItem['fitData'] = 0
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        for (var i = 1; i < eventData['measured_parameters'].length; i++) {
          var measurementIDToCompare = new Date(measurementID)
          if (isNaN(measurementID) === false) {
            measurementIDToCompare = new Date(measurementID * 1000)
          }
          var eventMeasurementID = eventData['measured_parameters'][i]['measurement_id']
          if (isNaN(eventMeasurementID) === false) {
            eventMeasurementID = eventMeasurementID * 1000
          }
          eventMeasurementID = new Date(eventMeasurementID)
          if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-calibration' &&
            eventMeasurementID >= measurementIDToCompare) {
            basebandItem['fitData'] = eventData['measured_parameters'][i]
            measurementID = eventData['measured_parameters'][i]['measurement_id']
          }
        }
        basebandItem['processedAt'] = this.getProcessedAt(measurementID)
        // Pad beam number with '0' to four digits
        var burstDate = eventData['measured_parameters'][0]['datetime']
        basebandItem['data'] = '/data/chime/baseband/processed/' +
                                burstDate.split(' ')[0].split('-')[0] +
                                '/' +
                                burstDate.split(' ')[0].split('-')[1] +
                                '/' +
                                burstDate.split(' ')[0].split('-')[2] +
                                '/astro_' +
                                eventData['id'] +
                                '/baseband_automatic_pipeline.png'
        this.basebandItems.push(basebandItem)
      } catch (e) {
        console.error(e)
      }
    },
    parseFitburst (eventData) {
      try {
        var firstRound = {}
        var secondRound = {}
        var thirdRound = {}
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        for (var i = 1; i < eventData['measured_parameters'].length; i++) {
          var measurementIDToCompare = new Date(measurementID)
          if (isNaN(measurementID) === false) {
            measurementIDToCompare = new Date(measurementID * 1000)
          }
          var eventMeasurementID = eventData['measured_parameters'][i]['measurement_id']
          if (isNaN(eventMeasurementID) === false) {
            eventMeasurementID = eventMeasurementID * 1000
          }
          eventMeasurementID = new Date(eventMeasurementID)
          if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-fitburst' &&
            eventMeasurementID >= measurementIDToCompare) {
            measurementID = eventData['measured_parameters'][i]['measurement_id']
          }
        }
        firstRound['processedAt'] = this.getProcessedAt(measurementID)
        secondRound['processedAt'] = this.getProcessedAt(measurementID)
        thirdRound['processedAt'] = this.getProcessedAt(measurementID)
        // Get fit data for all rounds with right measurement ID
        var snrs = {'round2': 0, 'round3': 0}
        for (i = 0; i < eventData['measured_parameters'].length; i++) {
          if (eventData['measured_parameters'][i]['measurement_id'] === measurementID) {
            if (eventData['measured_parameters'][i]['pipeline']['logs'].split(' ')[1] === '1') {
              var model = 'Gaussian'
              if ('sub_burst_spectral_running' in eventData['measured_parameters'][i] ||
                  'sub_burst_spectral_index' in eventData['measured_parameters'][i]) {
                model = 'Spectral'
              }
              firstRound['fitData'] = eventData['measured_parameters'][i]
              firstRound['fitData']['pulse_model'] = model
            } else if (eventData['measured_parameters'][i]['pipeline']['logs'].split(' ')[1] === '2') {
              secondRound['fitData'] = eventData['measured_parameters'][i]
              secondRound['fitData']['pulse_model'] = model
              if (Object.keys(secondRound['fitData']).includes('snr')) {
                snrs['round2'] = secondRound['fitData']['snr']
              }
            } else {
              thirdRound['fitData'] = eventData['measured_parameters'][i]
              thirdRound['fitData']['pulse_model'] = model
              if (Object.keys(thirdRound['fitData']).includes('snr')) {
                snrs['round3'] = thirdRound['fitData']['snr']
              }
            }
          }
        }
        var showText = ''
        if (snrs['round2'] === 0 && snrs['round3'] === 0) {
          showText = 'Both rounds have failed. Make sure that the DM pipeline output is fine. If it is, re-run the pipeline with better input parameters. If not, first rerun the DM pipeline.'
        }
        if (snrs['round2'] > snrs['round3']) {
          showText = 'Round 2 is a better fit according to fitburst. Make sure that round 2 is as good as or better than round 1. If round 2 is truly statistically better than round 3, you should not see any evidence for scattering. It is ok if round 3 has failed, as long as you do not see a hint of scattering in the waterfall plots. If you can see scattering, it needs to be rerun with better parameters and round 3 should be the preferred model.'
        } else {
          showText = 'Round 3 is a better fit according to fitburst. Make sure that it looks equivalent or better than round 2. Also make sure that the residuals in round 3 look acceptable. Otherwise, it needs to be rerun with better input parameters.'
        }
        firstRound['showText'] = showText
        secondRound['showText'] = showText
        thirdRound['showText'] = showText
        // Pad beam number with '0' to four digits
        var mainBeam = ('0000' + firstRound['fitData']['beam_number']).substr(-4, 4)
        var burstDate = eventData['measured_parameters'][0]['datetime']
        var filePath = '/data/chime/intensity/processed/' +
                         burstDate.split(' ')[0].split('-')[0] +
                         '/' +
                         burstDate.split(' ')[0].split('-')[1] +
                         '/' +
                         burstDate.split(' ')[0].split('-')[2] +
                         '/astro_' +
                         eventData['id'] +
                         '/'
        filePath = filePath + mainBeam + '/intensity-fitburst/' + eventData['id'] + '_' + mainBeam + '_'
        // Generate all file names for fitburst generated plots
        firstRound['plot'] = filePath + 'round_one_fitburst_triptych.png'
        firstRound['correlations'] = filePath + 'round_one__fitburst_correlations.png'
        secondRound['plot'] = filePath + 'round_two_fitburst_triptych.png'
        secondRound['correlations'] = filePath + 'round_two__fitburst_correlations.png'
        thirdRound['plot'] = filePath + 'round_three_fitburst_triptych.png'
        thirdRound['correlations'] = filePath + 'round_three__fitburst_correlations.png'
        firstRound['pubplot'] = filePath + 'round_one_pubplot.png'
        secondRound['pubplot'] = filePath + 'round_two_pubplot.png'
        thirdRound['pubplot'] = filePath + 'round_three_pubplot.png'
        firstRound['peakplot'] = filePath + 'round_one_detected_peaks.png'
        secondRound['peakplot'] = filePath + 'round_one_detected_peaks.png'// only 1 plot exists
        thirdRound['peakplot'] = filePath + 'round_one_detected_peaks.png'// only 1 plot exists
        // this.fitburstItems.push(firstRound)
        this.fitburstItems.push(secondRound)
        this.fitburstItems.push(thirdRound)
      } catch (e) {
        console.error(e)
      }
    },
    parseFitburstMCMC (eventData) {
      try {
        var firstRound = {}
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        for (var i = 1; i < eventData['measured_parameters'].length; i++) {
          var measurementIDToCompare = new Date(measurementID)
          if (isNaN(measurementID) === false) {
            measurementIDToCompare = new Date(measurementID * 1000)
          }
          var eventMeasurementID = eventData['measured_parameters'][i]['measurement_id']
          if (isNaN(eventMeasurementID) === false) {
            eventMeasurementID = eventMeasurementID * 1000
          }
          eventMeasurementID = new Date(eventMeasurementID)
          if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-mcmc-scattered_pulse_model' &&
            eventMeasurementID >= measurementIDToCompare) {
            measurementID = eventData['measured_parameters'][i]['measurement_id']
            firstRound['fitData'] = eventData['measured_parameters'][i]
          }
        }
        firstRound['processedAt'] = this.getProcessedAt(measurementID)
        // Pad beam number with '0' to four digits
        var mainBeam = ('0000' + firstRound['fitData']['beam_number']).substr(-4, 4)
        var burstDate = eventData['measured_parameters'][0]['datetime']
        var filePath = '/data/chime/intensity/processed/' +
                         burstDate.split(' ')[0].split('-')[0] +
                         '/' +
                         burstDate.split(' ')[0].split('-')[1] +
                         '/' +
                         burstDate.split(' ')[0].split('-')[2] +
                         '/astro_' +
                         eventData['id'] +
                         '/'

        filePath = filePath + mainBeam + '/intensity-fitburst/'
        // Generate all file names for fitburst generated plots
        firstRound['corner'] = filePath + eventData['id'] + '_' + mainBeam + '_cornerplot_for_scattering_model.png'
        firstRound['plot'] = filePath + eventData['id'] + '_' + mainBeam + '_mcmc_scattering_triptych.png'
        this.fitburstMCMCItems.push(firstRound)
      } catch (e) {
        console.error(e)
      }
    },
    notesSelected (evItem, index, button) {
      this.eventId = evItem.event_id
      this.takenNotes = evItem['notes']
    },
    saveNotes () {
      var payload = {}
      payload['candidate_id'] = this.eventId
      payload['user'] = localStorage.username
      var d = new Date()
      payload['notes'] = d + ' : ' + this.eventNotes
      var url = this.mybaseUrl + '/v1/analysis/event-notes'
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(url, payload, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          if (response.status === 200) {
            this.rerunfitburst = true
          }
        })
    },
    rerunFitburst () {
      var width = this.intensityDmPipelineItems[0]['fitData']['width'] / 3
      var window = null
      var widthBound = null
      if (width) {
        window = width * 10
        widthBound = width * 2
      }

      var dm = this.intensityDmPipelineItems[0]['fitData']['dm_snr']
      var dmBound = this.intensityDmPipelineItems[0]['fitData']['dm_snr_error'] * 2
      var timeBound = null
      if (dmBound) {
        timeBound = dmBound * 0.02
      }
      var propertyMap = {
        dm: dm,
        width: width,
        scatteringtimescale: 0.0001,
        window: window,
        iterations: 1,
        dm_bound: dmBound,
        width_bound: widthBound,
        time_bound: timeBound,
        freqmean: 600.0,
        fixdm: false,
        freqwidth: 400.0,
        badchannelmask: false,
        fixwindow: false,
        burst_band: 'narrow',
        components: 1,
        peaksep: 1,
        peakfrac: 1.0
      }
      if (this.fitburstForm.multicomponent === false) {
        this.fitburstForm.components = propertyMap['components']
        this.fitburstForm.peaksep = propertyMap['peaksep']
        this.fitburstForm.peakfrac = propertyMap['peakfrac']
      }
      delete this.fitburstForm.multicomponent
      // Generate list of parameters to run fitburst
      var intensityFitburstParameters = {
        'eventid': parseInt(this.fitburstForm['id'])
      }
      for (var property in this.fitburstForm) {
        if (typeof this.fitburstForm[property] === 'boolean' || property === 'burst_band') {
          intensityFitburstParameters[property] = this.fitburstForm[property]
        } else if (typeof this.fitburstForm[property] === 'string' && this.fitburstForm[property] !== '' && property !== 'burst_band') {
          intensityFitburstParameters[property] = parseFloat(this.fitburstForm[property])
        }
        if (this.fitburstForm[property] == null) {
          // fetch from propertyMap (default values)
          if (property === 'time_bound') {
            if (this.fitburstForm['dm_bound']) {
              intensityFitburstParameters['time_bound'] = parseFloat(this.fitburstForm['dm_bound']) * 0.02
            } else {
              intensityFitburstParameters['time_bound'] = propertyMap['time_bound']
            }
          } else if (property === 'width_bound') {
            if (this.fitburstForm['width']) {
              intensityFitburstParameters['width_bound'] = parseFloat(this.fitburstForm['width']) * 2
            } else {
              intensityFitburstParameters['width_bound'] = propertyMap['width_bound']
            }
          } else if (property === 'window') {
            if (this.fitburstForm['width']) {
              intensityFitburstParameters['window'] = parseFloat(this.fitburstForm['width']) * 10
            } else {
              intensityFitburstParameters['window'] = propertyMap['window']
            }
          } else {
            if (propertyMap[property]) {
              intensityFitburstParameters[property] = propertyMap[property]
            } else {
              intensityFitburstParameters[property] = null
            }
          }
        }
      }

      this.fitburstForm.multicomponent = false
      const intensityFitburstPayload = {
        'attempt': 0,
        'config': {'archive': {'results': true}},
        'creation': Date.now() / 1000,
        'event': [intensityFitburstParameters['eventid']],
        'id': null,
        'parameters': intensityFitburstParameters,
        'pipeline': 'intensity-fitburst',
        'plots': null,
        'priority': 5,
        'products': null,
        'results': null,
        'retries': 3,
        'site': 'chime',
        'start': null,
        'status': 'created',
        'stop': null,
        'tags': null,
        'timeout': 3600,
        'user': localStorage.username
      }
      var bucketsUrl = 'https://frb.chimenet.ca/buckets/work/'
      this.rerunfitburst = false
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(bucketsUrl, [intensityFitburstPayload], {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          if (response.status === 200) {
            this.rerunfitburst = true
          }
        }, response => {
          console.error('Rerun intensity fitburst failed to deposit work')
          console.error(response.body)
        })
    },
    monitorJob (job) {
      var url = '/frb-web/cluster?job=' + job// + (this.eventId || '')
      var routeData = this.$router.resolve(url)
      window.open(routeData.href, '_blank')
    },
    rerunHeaderLocalization () {
      var headerLocalizationPayload = {
        'attempt': 0,
        'config': {'archive': {'results': true}},
        'creation': Date.now() / 1000,
        'event': [parseInt(this.headerLocPipelineForm['id'])],
        'id': null,
        'parameters': {'event_ids': [parseInt(this.headerLocPipelineForm['id'])]},
        'pipeline': 'header-localization',
        'plots': null,
        'priority': 5,
        'products': null,
        'results': null,
        'retries': 3,
        'site': 'chime',
        'start': null,
        'status': 'created',
        'stop': null,
        'tags': null,
        'timeout': 3600,
        'user': localStorage.username
      }
      var bucketsUrl = 'https://frb.chimenet.ca/buckets/work/'
      this.rerunheaderloc = false
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(bucketsUrl, [headerLocalizationPayload], {responseType: 'json', timeout: 10000}, {headers: authHeaders})
        .then(response => {
          if (response.status === 200) {
            this.rerunheaderloc = true
          }
        }, response => {
          console.error('Rerun header localization failed to deposit work')
          console.error(response.body)
        })
    },
    rerunIntensityDMPipeline () {
      var intensityDMParameters = {'event_id': parseInt(this.intensityDMPipelineForm['id'])}
      var floatTypeProperties = ['input_dm', 'dm_range']
      var intTypeProperties = ['downsample_factor']
      var listOfFloatTypeProperties = ['fcenter', 'bandwidth_guess']
      for (var property in this.intensityDMPipelineForm) {
        if (typeof this.intensityDMPipelineForm[property] === 'string') {
          if (this.intensityDMPipelineForm[property] === '' || property === 'id') {
            continue
          }
          if (floatTypeProperties.includes(property)) {
            intensityDMParameters[property] = parseFloat(this.intensityDMPipelineForm[property])
          } else if (intTypeProperties.includes(property)) {
            intensityDMParameters[property] = parseInt(this.intensityDMPipelineForm[property])
          } else if (listOfFloatTypeProperties.includes(property)) {
            intensityDMParameters[property] = JSON.parse(this.intensityDMPipelineForm[property])
          }
        }
      }
      var intensityDMPayload = {
        'attempt': 0,
        'config': {'archive': {'results': true}},
        'creation': Date.now() / 1000,
        'event': [parseInt(this.intensityDMPipelineForm['id'])],
        'id': null,
        'parameters': intensityDMParameters,
        'pipeline': 'intensity-dm-pipeline',
        'plots': null,
        'priority': 5,
        'products': null,
        'results': null,
        'retries': 3,
        'site': 'chime',
        'start': null,
        'status': 'created',
        'stop': null,
        'tags': null,
        'timeout': 3600,
        'user': localStorage.username
      }
      var bucketsUrl = 'https://frb.chimenet.ca/buckets/work/'
      this.rerunIntensityDM = false
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(bucketsUrl, [intensityDMPayload], {responseType: 'json', timeout: 10000}, {headers: authHeaders})
        .then(response => {
          if (response.status === 200) {
            this.rerunIntensityDM = true
          }
        }, response => {
          console.error('Rerun intensity DM failed to deposit work')
          console.error(response.body)
        })
    },
    rerunIntensityCalibration () {
      var intensityCalibrationParameters = ['submit-calibration-jobs.py']
      // Generate list of parameters to run fitburst
      for (var property in this.intensityCalibrationForm) {
        if (typeof this.intensityCalibrationForm[property] === 'string') {
          if (this.intensityCalibrationForm[property] === '') {
            continue
          }
          intensityCalibrationParameters.push(this.intensityCalibrationForm[property])
        }
      }
      const work = {
        'event_no': parseInt(intensityCalibrationParameters[1])
      }
      if (intensityCalibrationParameters.length > 2) {
        work['extend_window_left'] = intensityCalibrationParameters[2]
      }
      if (intensityCalibrationParameters.length > 3) {
        work['extend_window_right'] = intensityCalibrationParameters[3]
      }
      work['pipeline_user'] = localStorage.username
      const payload = {
        'work': [JSON.stringify(work)],
        'priority': 'low'
      }
      this.rerunintensitycalibration = false
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      const jobUrl = 'https://frb.chimenet.ca/maestro/buckets/work/calibrate-intensity'
      this.$http.post(jobUrl, payload, {headers: authHeaders}, {responseType: 'json', timeout: 10000}, {headers: authHeaders})
        .then(response => {
          if (response.status === 200) {
            this.rerunintensitycalibration = true
          }
        })
    },
    saveParameters (pipeline) {
      this.refreshToken()
      var lockUrl = this.mybaseUrl + 'v1/events/lock-measured-parameters/' + this.eventId + '/' + pipeline
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.put(lockUrl, {responseType: 'json', timeout: 10000}, {headers: authHeaders})
        .then(response => {

        })
      var myTimerPromise = this.waitForIt(2000) // wait for 2 seconds
      Promise.all([myTimerPromise]).then(() => {
        this.save(pipeline)
      })
    },
    save (pipeline) {
      var lockUrl = this.mybaseUrl + '/v1/analysis/save/' + this.eventId + '/' + pipeline + '/' + localStorage.username
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(lockUrl, {responseType: 'json', timeout: 10000}, {headers: authHeaders})
        .then(response => {
          if (response.status === 200) {
            alert('You have successfully saved the results for ' + pipeline + ' for event: ' + this.fitburstForm.eventid)
          } else {
            alert('Could not save results due to error: Status Code:' + response.status + ' Response Text:' + response.text)
          }
        })
    },
    unsaveParameters (pipeline) {
      this.refreshToken()
      var lockUrl = this.mybaseUrl + 'v1/events/unlock-measured-parameters/' + this.eventId + '/' + pipeline
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.put(lockUrl, {responseType: 'json', timeout: 10000}, {headers: authHeaders})
        .then(response => {

        })
      var myTimerPromise = this.waitForIt(2000) // wait for 2 seconds
      Promise.all([myTimerPromise]).then(() => {
        this.unsave(pipeline)
      })
    },
    unsave (pipeline) {
      var lockUrl = this.mybaseUrl + '/v1/analysis/unsave/' + this.eventId + '/' + pipeline + '/' + localStorage.username
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(lockUrl, {responseType: 'json', timeout: 10000}, {headers: authHeaders})
        .then(response => {
          if (response.status === 200) {
            alert('You have successfully un-saved the results for ' + pipeline + ' for event: ' + this.fitburstForm.eventid)
          } else {
            alert('Could not un-save results due to error: Status Code:' + response.status + ' Response Text:' + response.text)
          }
        })
    },
    flagParameters (pipeline) {
      this.refreshToken()
      var lockUrl = this.mybaseUrl + '/v1/analysis/flag/' + this.eventId + '/' + pipeline + '/' + localStorage.username
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(lockUrl, {responseType: 'json', timeout: 10000}, {headers: authHeaders})
        .then(response => {
          if (response.status === 200) {
            alert('You have successfully flagged the results for ' + pipeline + ' for event: ' + this.fitburstForm.eventid)
          } else {
            alert('Could not flag results due to error: Status Code:' + response.status + ' Response Text:' + response.text)
          }
        })
    },
    badParameters (pipeline) {
      var lockUrl = this.mybaseUrl + '/v1/analysis/bad/' + this.eventId + '/' + pipeline + '/' + localStorage.username
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(lockUrl, {headers: authHeaders}, {responseType: 'json', timeout: 10000}, {headers: authHeaders})
        .then(response => {
          if (response.status === 200) {
            alert('You have successfully updated the results for ' + pipeline + ' for event: ' + this.fitburstForm.eventid)
          } else {
            alert('Could not update results due to error: Status Code:' + response.status + ' Response Text:' + response.text)
          }
        })
    },
    hideEvents () {
      var x = document.getElementById('eventInfo')
      x.style.display = 'none'
      x = document.getElementById('eventViewer')
      x.style.display = 'none'
    },
    hideSource () {
      var x = document.getElementById('eventViewer')
      x.style.display = 'none'
    },
    showDiagnostics () {
      this.$root.$emit('bv::show::modal', 'modalplots')
    },
    refreshOriginalList () {
      this.hideEvents()
      this.reloadData()
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    refreshToken () {
      if (localStorage.refreshToken && localStorage.accessToken && localStorage.username) {
        var url = this.baseUrl + 'auth/refresh'
        var authHeaders = {'Authorization': localStorage.accessToken}
        // var authHeaders = {'Authorization': localStorage.accessToken}
        var refreshPayload = {'refresh_token': localStorage.refreshToken}
        this.$http.post(url, refreshPayload, {headers: authHeaders})
          .then(user => {
            localStorage.accessToken = user.body.access_token
            localStorage.accessTime = Date.now() / 1000
          }, user => {
            this.$router.replace(this.$route.query.redirect || '/frb-web/login')
          })
      } else {
        this.$router.replace(this.$route.query.redirect || '/frb-web/login')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/analysisMixin.js